// ShiftsPage.jsx or ShiftsPage.tsx
import React from "react";
import Navbar from "../../_Layouts/Navbar/Navbar";
import ShiftManagement from "../../Components/Users/ShiftsManagement";

const ShiftsPage = () => {
  return (
    <div>
      <Navbar titre={"Gestion des Shifts"} />
      <div className="page-container">
        <ShiftManagement />
      </div>
    </div>
  );
};

export default ShiftsPage;